import styled from 'styled-components';

export const StyledBarcodeScanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props): string => props.theme.kcc.spacing.BASE};
  flex: 1;
  max-width: 755px;

  .barcode-scanner__card {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1.5px dashed ${(props): string => props.theme.kcc.colors.GRAY_400};
    border-radius: ${(props): number => props.theme.kcc.borderRadius.INPUT}px;
    padding: ${(props): string => props.theme.kcc.spacing.LG} ${(props): string => props.theme.kcc.spacing.BASE};
    text-align: center;
  }

  .barcode-scanner__icon {
    svg {
      width: 48px;
      height: 48px;
    }
  }

  .barcode-scanner__title {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.LG}px;
    margin-top: ${(props): string => props.theme.kcc.spacing.BASE};
    margin-bottom: ${(props): string => props.theme.kcc.spacing.XXS};
  }

  .barcode-scanner__description {
    font-size: ${(props): number => props.theme.kcc.typography.FONT_SIZE.BASE}px;
    color: ${(props): string => props.theme.kcc.colors.GRAY_600};
    line-height: ${(props): number => props.theme.kcc.typography.LINE_HEIGHT.BASE};
    margin-bottom: 0;
  }

  .barcode-scanner__scan-btn {
    width: 100%;
    margin-top: ${(props): string => props.theme.kcc.spacing.SM};
  }

  .barcode-scanner__or {
    text-align: center;
  }

  .barcode-scanner__manual-btn {
    width: 100%;
  }

  .barcode-scanner__not-your-machine {
    margin: 0;
  }

  .barcode-scanner__not-your-machine-link {
    text-decoration: underline;
    cursor: pointer;
    color: ${(props): string => props.theme.kcc.colors.TEXT};
    margin: 0;
  }
`;
